/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2023] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SaveDeliverySchedules(objectID, objectTypeCode, deliverySchedules) {
  const deliverySchedulesFormatted = _.map(deliverySchedules, (x) => {
    return {
      ID: x.id,
      Note: x.note,
      LineItemDetails: {
        AdditionalServiceID: x.additionalServiceId,
        AdditionalAccessoryID: x.additionalAccessoryId,
        TermingSerialNumber: x.termingSerialNumber,
        IsReplacement: x.isReplacement,
        NMCIOneNet: x.nmciOneNet,
        Network: x.network,
        TrainingTypeID: x.trainingTypeId,
        CommandEchelon: x.commandEchelon
      },
      Address: {
        Address1: x.address.addressLine1,
        Address2: x.address.addressLine2,
        BuildingFloorNumber: x.address.buildingFloorNumber,
        FloorNumber: x.address.floorNumber,
        RoomNumber: x.address.roomNumber,
        PoleNumber: x.address.poleNumber,
        Suite: x.address.suite,
        RoomPoleNumber: x.address.roomPoleNumber,
        City: x.address.city,
        Zip: x.address.zip,
        RegionID: x.address.regionId
      },
      DeliveryPOC: {
        FirstName: x.deliveryPOCFirstName,
        LastName: x.deliveryPOCLastName,
        Email: x.deliveryPOCEmail,
        Phone: x.deliveryPOCPhone
      },
      ITPOC: {
        FirstName: x.itPOCFirstName,
        LastName: x.itPOCLastName,
        Email: x.itPOCEmail,
        Phone: x.itPOCPhone
      },
      FinPOC: {
        FirstName: x.finPOCFirstName,
        LastName: x.finPOCLastName,
        Email: x.finPOCEmail,
        Phone: x.finPOCPhone
      }
    };
  });

  const response = await $.soap({
    body: {
      SaveDeliverySchedules: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order_delivery_schedule',
        ObjectID: objectID,
        ObjectTypeCode: objectTypeCode,
        DeliverySchedules: { DeliverySchedule: deliverySchedulesFormatted }
      }
    }
  });

  cleanUpResponse(response);
  return response.orders;
}
